/**
 * 申请售后相关API
 */

import request from '@/utils/request'

/**
 * 获取短信验证码
 * @params params
 * @returns {AxiosPromise}
 */
export function getOPT(params) {
  return request({
    url: `/register/smscode/${params.mobile}`,
    method: 'post',
    needToken: false,
    loading: true,
    data: params
  })
}
/**
 * 验证验证码
 * @type 验证码类型
 * @val 手机 / 邮箱号
 * @params params
 * @returns {AxiosPromise}
 */
export function checkCode(type, val, params) {
  return request({
    url: `/register/checkcode/${type}/${val}`,
    method: 'post',
    needToken: false,
    loading: true,
    data: params
  })
}
/**
 * 注册
 * @params params
 * @returns {AxiosPromise}
 */
export function register( params) {
  return request({
    url: `/register`,
    method: 'post',
    needToken: false,
    loading: true,
    data: params
  })
}

/**
 * 生成图片验证码
 * @uuid
 * @scene 登录=LOGIN，注册=REGISTER
 * @returns {AxiosPromise}
 */
export function captchas(uuid, scene) {
  return request({
    url: `/captchas/${uuid}/${scene}`,
    method: 'get',
    ApiBase: true,
    needToken: false,
    loading: true,
  })
}

/**
 * 用户名登录
 * @params
 * @returns {AxiosPromise}
 */
export function login(params) {
  return request({
    url: `/login`,
    method: 'post',
    needToken: false,
    loading: true,
    data: params
  })
}

/**
 * 刷新token
 * @params
 * @returns {AxiosPromise}
 */
export function refreshToken(params) {
  return request({
    url: `/verify/refresh`,
    method: 'post',
    needToken: false,
    loading: true,
    data: params
  })
}

/**
 * 获取用户信息
 * @params
 * @returns {AxiosPromise}
 */
export function getUserInfo() {
  return request({
    url: `/user/info`,
    method: 'post',
    needToken: true,
    loading: true
  })
}

/**
 * 第三方账户绑定
 * @param
 * @returns {AxiosPromise}
 */
export function userBind(params) {
  return request({
    url: `/user/userBind`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 第三方账户解除绑定
 * @param
 * @returns {AxiosPromise}
 */
export function unBind(params) {
  return request({
    url: `/user/untying`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * sso登录
 * @param
 * @returns {AxiosPromise}
 */
export function ssoLogin(params) {
  return request({
    url: `/login/ssoLogin`,
    method: 'post',
    needToken: false,
    loading: true,
    data: params
  })
}

/**
 * 初始化密码
 * @param
 * @returns {AxiosPromise}
 */
export function initPassword(params) {
  return request({
    url: `/user/setpaypwd`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 验证手机是否重复
 * @param
 * @returns {AxiosPromise}
 */
export function checkMobile(params) {
  return request({
    url: `/verify/checkmobile`,
    method: 'post',
    needToken: false,
    loading: true,
    data: params
  })
}

/**
 * 验证邮箱是否重复
 * @param
 * @returns {AxiosPromise}
 */
export function checkEmail(params) {
  return request({
    url: `/verify/checkemail`,
    method: 'post',
    needToken: false,
    loading: true,
    data: params
  })
}

/**
 * 修改用户头像
 * @param
 * @returns {AxiosPromise}
 */
export function updateHeadImg(params) {
  return request({
    url: `/head/image/update`,
    method: 'post',
    needToken: true,
    loading: true,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: params
  })
}

/**
 * 获取站内信
 * @param
 * @returns {AxiosPromise}
 */
export function msgList(params) {
  return request({
    url: `/user/message/list`,
    method: 'get',
    needToken: true,
    loading: true,
    params: params
  })
}

/**
 * 获取站内信
 * @param
 * @returns {AxiosPromise}
 */
export function editState(params) {
  return request({
    url: `/user/message/re_state`,
    method: 'get',
    needToken: true,
    loading: false,
    params: params
  })
}

/**
 * 发送修改密码验证码
 * @param
 * @returns {AxiosPromise}
 */
export function pwdSMS() {
  return request({
    url: `/user/pwd/smscode`,
    method: 'post',
    needToken: true,
    loading: true
  })
}

/**
 * 发送修改密码邮件验证码
 * @param
 * @returns {AxiosPromise}
 */
export function pwdEmail() {
  return request({
    url: `/user/paypwd/emailcode`,
    method: 'post',
    needToken: true,
    loading: true
  })
}

/**
 * 修改登录密码
 * @param
 * @returns {AxiosPromise}
 */
export function editpwd(params) {
  return request({
    url: `/user/editpwd`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 支付密码修改登录密码
 * @param
 * @returns {AxiosPromise}
 */
export function editpwds(params) {
  return request({
    url: `/user/editpwds`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 发送修改支付密码验证码
 * @param
 * @returns {AxiosPromise}
 */
export function paypwdSMS() {
  return request({
    url: `/user/paypwd/smscode`,
    method: 'post',
    needToken: true,
    loading: true
  })
}

/**
 * 修改支付密码
 * @param
 * @returns {AxiosPromise}
 */
export function editpaypwd(params) {
  return request({
    url: `/user/editpaypwd`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 支付密码修改支付密码
 * @param
 * @returns {AxiosPromise}
 */
export function editpaypwds(params) {
  return request({
    url: `/user/editpaypwds`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 邮件修改支付密码
 * @param
 * @returns {AxiosPromise}
 */
export function editpaypwdsEmail(params, type) {
  return request({
    url: `/user/editpaypwd/${type}`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 验证修改密码验证码或修改支付密码验证码
 * @param
 * 场景(修改密码：MODIFY_LOGIN_PASSWORD，修改支付密码：MODIFY_PAY_PASSWORD)
 * @returns {AxiosPromise}
 */
export function verifycode(params) {
  return request({
    url: `/user/verifycode`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 发送验证码到新手机号（第一步）
 * @param
 * @returns {AxiosPromise}
 */
export function verify_new_mobile(mobile, gr) {
  return request({
    url: `/info/verify_new_mobile`,
    method: 'post',
    needToken: true,
    loading: true,
    data: { mobile, gr }
  })
}

/**
 * 修改手机号（完成）
 * @param
 * @returns {AxiosPromise}
 */
export function resetMobile(params) {
  return request({
    url: `/info/remobile`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}

/**
 * 发送验证码到新邮箱（第一步）
 * @param
 * @returns {AxiosPromise}
 */
export function verify_email( email ) {
  return request({
    url: `/info/verify_email`,
    method: 'post',
    needToken: true,
    loading: true,
    data: { email }
  })
}

/**
 * 修改手机号（完成）
 * @param
 * @returns {AxiosPromise}
 */
export function resetEmail(params) {
  return request({
    url: `/info/remail`,
    method: 'post',
    needToken: true,
    loading: true,
    data: params
  })
}
